import { useState, useEffect } from "react";
import "./App.css";
import Home from "./pages/Home";
import Web3 from "web3";
import { contractAbi, contractAddress } from "./contracts/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { InformationModal, ConfirmationLoadingPopup } from "./components";
import axios from "axios";
import Web3Modal from "web3modal";
import trustwallet from "./assets/trustwallet.png";
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";
import Swap from "./pages/Swap";
import { Routes, Route } from "react-router-dom";
import moment from "moment";
import Howto from "./pages/Howto";
function App() {
  // const [chainId, setChainId] = useState(null);
  // const [account, setAccount] = useState("");
  const [contract, setContract] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [price, setPrice] = useState(0);
  const [bnbBalance, setBnbBalance] = useState(0);
  const [icoPrice, setIcoPrice] = useState(0);
  const [totalSupply, setTotalSupply] = useState(0);
  const [tokenSold, setTokenSold] = useState(0);
  const [userTokenBalance, setUserTokenBalance] = useState(0);
  //FOR POPUP
  const [accessAccountDenied, setAccessAccountDenied] = useState(false);
  const [installEthereum, setInstallEthereum] = useState(false);
  const [nftMinted, setNftMinted] = useState(false);
  const [nftMinting, setNftMinting] = useState(false);
  const [transactionRejected, setTransactionRejected] = useState(false);
  const [transactionFailed, setTransactionFailed] = useState(false);
  const [switchToMainnet, setswitchToMainnet] = useState(false);
  const [ethereumCompatibleBrowser, setEthereumCompatibleBrowser] =
    useState(false);
  const [mintingInProgress, setMintingInProgress] = useState(false);
  const [confirmTransaction, setConfirmTransaction] = useState(false);
  const [lessValueWarn, setLessValueWarn] = useState(false);
  const [whitelist, setWhitelist] = useState(false);
  const [paused, setPaused] = useState(false);
  const successNotificationID = "successNotificationID";
  const failureNotificationID = "failureNotificationID";
  const [account, setAccount] = useState(undefined);
  const [chainId, setChainId] = useState(undefined);
  const [iWeb3, setIWeb3] = useState(null);
  const [data, setData] = useState({});

  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [provider, setProvider] = useState({
    on: () => {},
  });

  const CONNECTABLE_CHAINID = 56;
  const BASE_URL = "https://defi.mobiwebsolutionz.com/api/dblit";

  useEffect(() => {
    const getData = async () => {
      try {
        const { data } = await axios.get(
          `${BASE_URL}/get-ico-details-live.php`
        );

        setData(data.data);
        console.log("DATA:", data.data);
      } catch (error) {
        console.log(error);
      }
    };
    getData();
  }, []);

  // ================================================================================================ Start

  const providerOptions = {
    injected: {
      display: {
        logo: trustwallet,
        name: "Injected",
        description: "Connect with the provider in your Browser",
      },
      package: null,
    },
    walletconnect: {
      package: WalletConnectProvider,
      options: {
        rpc: {
          97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
          56: "https://bsc-dataseed.binance.org/",
        },
        infuraId: "9a29c26a16574eb1b8b8959e8aba86ed", // required
        // network: "binance",
      },
    },
    "custom-coinbase": {
      display: {
        logo: trustwallet,
        name: "Coinbase",
        description: "Scan with WalletLink to connect",
      },
      options: {
        appName: "app", // Your app name
        networkUrl: `https://mainnet.infura.io/v3/9a29c26a16574eb1b8b8959e8aba86ed`,
        rpc: {
          97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
          56: "https://bsc-dataseed.binance.org/",
        },
      },
      package: WalletLink,
      connector: async (_, options) => {
        const { appName, networkUrl, chainId } = options;
        const walletLink = new WalletLink({
          appName,
        });
        const provider = walletLink.makeWeb3Provider(networkUrl, chainId);
        await provider.enable();
        return provider;
      },
    },
  };

  const web3Modal = new Web3Modal({
    // network: "binance",
    cacheProvider: true,
    providerOptions,
  });

  const getWeb3Provider = async (connect = "injected") => {
    if (account) {
      //   // console.log(getInjectedProvider());
      await web3Modal.clearCachedProvider();
      window.location.reload();
      //   // await listenEvents(provider);
      //   // const web3 = new Web3(provider);
      //   // setProvider(provider);
      //   // setIWeb3(web3);
    } else {
      const provider = await web3Modal.connectTo(connect);
      await listenEvents(provider);
      const web3 = new Web3(provider);
      setProvider(provider);
      setIWeb3(web3);
    }
  };

  const isConnected = async () => {
    console.log("->", web3Modal.cachedProvider);

    if (web3Modal.cachedProvider === "walletconnect")
      web3Modal.clearCachedProvider();

    if (web3Modal.cachedProvider) {
      const provider = await web3Modal.connect();
      await listenEvents(provider);
    }
  };

  const listenEvents = async (provider) => {
    const web3 = new Web3(provider);
    setIWeb3(web3);

    const account = await web3.eth.getAccounts();
    const chainId = await web3.eth.getChainId();

    setAccount(account[0]);
    setChainId(chainId);

    provider.on("accountsChanged", (accounts) => {
      setAccount(accounts.length == 0 ? undefined : accounts[0]);
      accounts.length == 0 && web3Modal.clearCachedProvider();
    });

    // Subscribe to chainId change
    provider.on("chainChanged", (chainId) => {
      console.log("chainId", chainId);
      setChainId(chainId ? parseInt(chainId.toString(), 16) : undefined);
    });

    // Subscribe to provider connection
    provider.on("connect", (info) => {
      console.log("connect", info);
    });

    // Subscribe to provider disconnection
    provider.on("disconnect", (error) => {
      console.log("disconnect", error);
      window.location.reload();
    });
  };

  useEffect(() => {
    // console.log("cp", web3Modal.cachedProvider);
    isConnected();
  }, []);

  // useEffect(() => {
  //   account && method && fireToast();
  // }, [method]);

  useEffect(() => {
    (async () => {
      const localAccount = localStorage.getItem("account");
      if (localAccount === "metamask") {
        // loadWeb3();
        if (iWeb3 && account) {
          await loadBlockchainData();
          await loadWeb3();
        }
      }
    })();
  }, [iWeb3, account, chainId]);

  //for MetaMask

  async function loadWeb3() {
    if (iWeb3) {
      // window.web3 = new Web3(window.ethereum);

      try {
        // loadBlockchainData();
        // getCurrentAddressConnected();
        // addAccountsAndChainListener();
        // const accounts = await window.ethereum.request({
        //   method: "eth_requestAccounts",
        // });

        // setAccount(accounts[0]);

        // console.log("account:", account);

        const balance = await iWeb3.eth.getBalance(account);
        const balance_Eth = iWeb3.utils.fromWei(balance, "ether");
        // console.log("balance:", balance);
        // console.log("balance_Eth:", balance_Eth);
        setBnbBalance(balance_Eth);
        // console.log(bnbBalance);
      } catch (error) {
        if (error.code === 4001) {
          // swal("Request to access account denied!", "", "error");
          setAccessAccountDenied(true);
        } else console.error(error);
      }
    } else {
      setInstallEthereum(true);
      // swal(
      //   "",
      //   "Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!",
      //   "error"
      // );
    }
  }

  const loadBlockchainData = async () => {
    if (!iWeb3) return;
    const contract = new iWeb3.eth.Contract(contractAbi, contractAddress);
    setContract(contract);
    const chainId = await iWeb3.eth.getChainId();
    setChainId(chainId);
    //success when chainId = 97 else failure
    // you are connected to main net
    // Please connect to main net

    if (chainId === Number(CONNECTABLE_CHAINID)) {
      toast(`You are connected to BSC Mainnet`, {
        type: "success",
        position: toast.POSITION.BOTTOM_CENTER,
        toastId: successNotificationID,
      });
      const totalsupply = await contract.methods
        .getContractTokenBalance()
        .call();
      // const finalTotalSupply = window.web3.utils.fromWei(totalsupply, "ether");
      // console.log("totalSupply:", totalsupply);
      setTotalSupply(totalsupply);
      // console.log("total supply", totalsupply / 1000000000);

      const price = await contract.methods.presaleRate().call();
      setPrice(price / 100000000);
      // alert(price);
      console.log("Icoprice:", price / 100000000);
      const endTime = await contract.methods.endTime().call();
      console.log("endTime:", endTime);
      const startTime = await contract.methods.startTime().call();
      console.log("Start time:", startTime);
      const ICOtarget = await contract.methods.hardcap().call();
      const softcap = await contract.methods.softcap().call();
      console.log("IcoTARGET:", ICOtarget / 1000000000);
      const convertedICOPrice = Web3.utils.fromWei(price);
      setIcoPrice(price / 1000000000);
      console.log("icoprice:", convertedICOPrice);
      const tokensold = await contract.methods.tokenSold().call();
      const fundsRaised = await contract.methods.fundsRaised().call();
      // const finalTokenSold = window.web3.utils.fromWei(tokensold, "ether");
      // console.log("tokenSold:", tokensold / 1000000000);
      setTokenSold(tokensold);
      const postTokens = async () => {
        try {
          const response = await axios.post(`${BASE_URL}/update_ico.php`, {
            startTime: startTime,
            endTime: endTime,
            presaleRate: price,
            hardcap: ICOtarget,
            total_supply: totalsupply,
            total_sold: tokensold / 1000000000,
            funds_raised: fundsRaised,
            softcap: softcap,
            network: "mainnet",
          });
          console.log(response);
        } catch (error) {
          console.log(error);
        }
      };

      postTokens();
      const tokenBalance = await contract.methods
        .getUserTokenBalance()
        .call({ from: account });

      const tokenBalance_converted = iWeb3.utils.fromWei(tokenBalance, "ether");
      setUserTokenBalance(tokenBalance_converted);
      // console.log("User Token Balance:", tokenBalance);
    } else {
      toast("Please connect to BSC Mainnet", {
        type: "error",
        position: toast.POSITION.BOTTOM_CENTER,
        toastId: failureNotificationID,
      });
    }
  };
  useEffect(() => {
    changeNetwork();
  }, [chainId]);
  const changeNetwork = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [
            {
              chainId: Web3.utils.toHex(Number(process.env.REACT_APP_CHAIN_ID)),
            },
          ],
        });
      } catch (error) {
        console.error(error);
      }
    }
  };
  // const getCurrentAddressConnected = async () => {
  //   try {
  //     const accounts = await window.ethereum.request({
  //       method: "eth_accounts",
  //     });
  //     if (accounts.length > 0) {
  //       setAccount(accounts[0]);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const addAccountsAndChainListener = async () => {
  //   //this event will be emitted when the currently connected chain changes.
  //   window.ethereum.on("chainChanged", (_chainId) => {
  //     window.location.reload();
  //     // loadWeb3();
  //   });

  //   // this event will be emitted whenever the user's exposed account address changes.
  //   window.ethereum.on("accountsChanged", (accounts) => {
  //     window.location.reload();
  //     // loadWeb3();
  //   });
  // };

  async function buy(buyAmount) {
    if (contract) {
      // console.log("contract");
      if (chainId === Number(CONNECTABLE_CHAINID)) {
        const _isPaused = await contract.methods.isPaused().call();
        if (_isPaused) {
          setPaused(true);
        } else {
          const isPresaleWhitelistRequired = await contract.methods
            .presaleWhiteListRequired()
            .call();
          const isUserAllowed = await contract.methods
            .checkPresaleEligiblity(account)
            .call();
          // console.log(isPresaleWhitelistRequired, isUserAllowed);
          if (isPresaleWhitelistRequired && isUserAllowed !== true) {
            setWhitelist(true);
          } else {
            // console.log("chain");
            if (buyAmount === 0) {
              setLessValueWarn(true);
            } else {
              setConfirmTransaction(true);

              const finalPrice = iWeb3.utils.toWei(
                buyAmount.toString(),
                "ether"
              );

              await contract.methods
                .invest()
                .send({ from: account, value: finalPrice })
                .on("transactionHash", function () {
                  setConfirmTransaction(false);
                  setMintingInProgress(true);
                })
                .on("confirmation", function () {
                  // setNftMinted(true);
                  // setConfirmTransaction(false);
                  // setMintingInProgress(false);
                })
                .on("receipt", function () {
                  setNftMinted(true);
                  setConfirmTransaction(false);
                  setMintingInProgress(false);
                })
                .on("error", function (error, receipt) {
                  if (error.code === 4001) {
                    setNftMinted(false);
                    setTransactionRejected(true);
                    setConfirmTransaction(false);
                    setMintingInProgress(false);
                  } else {
                    setTransactionFailed(true);
                    setConfirmTransaction(false);
                    setMintingInProgress(false);
                    setNftMinted(false);
                  }
                });
            }
          }
        }
      } else {
        setswitchToMainnet(true);
      }
    } else {
      setEthereumCompatibleBrowser(true);
    }
  }

  var e = new Date(Number(data.endTime * 1000)).toUTCString();
  var s = new Date(Number(data.startTime * 1000)).toUTCString();
  const start = +new moment(`${s}`).utc() > +new Date();
  // const end = +new moment(`${s} 00:00:00`).utc() < +new Date();

  const difference = +new moment(`${start ? s : e}`).utc() - +new Date();

  useEffect(() => {
    const id = setTimeout(() => {
      if (difference > 0) {
        setDays(Math.floor(difference / (1000 * 60 * 60 * 24)));
        setHours(Math.floor((difference / (1000 * 60 * 60)) % 24));
        setMinutes(Math.floor((difference / 1000 / 60) % 60));
        setSeconds(Math.floor((difference / 1000) % 60));
      }
    }, 1000);

    return () => {
      clearTimeout(id);
    };
  });

  return (
    <>
      <div className="App">
        <Routes>
          <Route
            index
            element={
              <Home
                account={account}
                bnbBalance={bnbBalance}
                buy={buy}
                userTokenBalance={userTokenBalance}
                loadWeb3={getWeb3Provider}
                totalSupply={data.ICOtarget}
                totalSupplyFormated={data.ICOtarget_formatted}
                icoPrice={data.ICOprice}
                icoPriceFormated={data.ICOprice_formatted}
                fundsRaised={data.funds_raised}
                tokenSold={data.total_sold}
                tokenSoldFormated={data.total_sold_formatted}
                startTime={data.startTime}
                endTime={data.endTime}
                data={data}
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                difference={difference}
                BASE_URL={BASE_URL}
                CONNECTABLE_CHAINID={CONNECTABLE_CHAINID}
                // loadWeb3={loadWeb3}
                // loadWalleConnect={loadWalleConnect}
              />
            }
          />
          <Route
            path="/swap"
            element={
              <Swap
                iWeb3={iWeb3}
                account={account}
                bnbBalance={bnbBalance}
                buy={buy}
                icoPrice={price}
                totalSupply={totalSupply}
                tokenSold={tokenSold}
                userTokenBalance={userTokenBalance}
                icoPriceFormated={data.ICOprice_formatted}
                loadWeb3={getWeb3Provider}
                startTime={data.startTime}
                fundsRaised={data.funds_raised}
                endTime={data.endTime}
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                difference={difference}
                chainId={chainId}
                contract={contract}
                BASE_URL={BASE_URL}
                CONNECTABLE_CHAINID={CONNECTABLE_CHAINID}
              />
            }
          />
          <Route
            path="/howto"
            element={
              <Howto
                account={account}
                bnbBalance={bnbBalance}
                buy={buy}
                icoPrice={icoPrice}
                totalSupply={totalSupply}
                tokenSold={tokenSold}
                userTokenBalance={userTokenBalance}
                icoPriceFormated={data.ICOprice_formatted}
                loadWeb3={getWeb3Provider}
                startTime={data.startTime}
                fundsRaised={data.funds_raised}
                endTime={data.endTime}
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                difference={difference}
                BASE_URL={BASE_URL}
                CONNECTABLE_CHAINID={CONNECTABLE_CHAINID}
              />
            }
          />
        </Routes>
      </div>
      <InformationModal
        open={lessValueWarn}
        onClose={setLessValueWarn}
        title="Alert!"
        text="Amount Should Not be 0"
      />
      <InformationModal
        open={whitelist}
        onClose={setWhitelist}
        title="Oops"
        text=" You are not whitelisted for the private sale."
      />
      <InformationModal
        open={paused}
        onClose={setPaused}
        title="Oops"
        text="Sale is Paused Please try later!"
      />
      <InformationModal
        open={accessAccountDenied}
        onClose={setAccessAccountDenied}
        title="Oops"
        text="Request to access account denied!"
      />
      <InformationModal
        open={installEthereum}
        onClose={setInstallEthereum}
        title="Oops"
        text="Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!"
      />
      <InformationModal
        open={nftMinted}
        onClose={setNftMinted}
        title="Transaction Successful"
        text="🎉Congrats, transaction completed successfully!"
        mint={true}
      />
      <InformationModal
        open={nftMinting}
        onClose={setNftMinting}
        title="Information"
        text="Purchasing NFT!"
      />
      <InformationModal
        open={transactionRejected}
        onClose={setTransactionRejected}
        title="Error"
        text="Transaction Rejected!"
      />
      <InformationModal
        open={transactionFailed}
        onClose={setTransactionFailed}
        title="Error"
        text="Transaction Failed!"
      />
      <InformationModal
        open={switchToMainnet}
        onClose={setswitchToMainnet}
        title="Error"
        text="Please switch to Mainnet"
      />
      <InformationModal
        open={ethereumCompatibleBrowser}
        onClose={setEthereumCompatibleBrowser}
        title="Error"
        text="Please install an Ethereum-compatible browser or extension like MetaMask to use this dApp!"
      />
      <ConfirmationLoadingPopup
        open={confirmTransaction}
        title="Confirm Transaction"
        message="Confirm transaction to Buy DBLIT"
      />
      <ConfirmationLoadingPopup
        open={mintingInProgress}
        title="Buying In Progress"
        message="Please wait to get confirmation of the transaction from blockchain"
      />
    </>
  );
}

export default App;
